// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles({
  container: {
    padding: '1em',
    width: '100%',
  },
  title: {
    textAlign: 'center',
    padding: '0.25em',
  },
  dataContent: {
    display: 'flex',
    justifyContent: 'center',
    borderRadius: '0.25em',
    backgroundColor: '#cecece',
    marginBottom: '1rem',
  },
  deviceDataContent: {
    display: 'flex',
    flexDirection: 'column-reverse',
    gap: '20px',
    borderRadius: '0.25em',
    marginTop: '-12px',
    maxHeight: '100vh',
    overflowY: 'auto'

  },
  resetButton: {
    margin: 'auto !important',
    display: 'flex !important',
    backgroundColor: '#222531 !important',
    justifyContent: 'space-between !important',
  },
  copyButton: {
    margin: 'auto !important',
    display: 'flex !important',
    backgroundColor: '#06d6a0 !important',
    justifyContent: 'space-between !important',
  },
  postButton: {
    margin: 'auto !important',
    display: 'flex !important',
    backgroundColor: '#d6063c !important',
    justifyContent: 'space-between !important',
  },
  createButton: {
    backgroundColor: '#06d6a0 !important',
    marginTop: '10px !important'
  },
  demoform: {
    margin: 'auto',
    padding: '1rem',
  },
  deviceForm: {
    margin: 'auto',
    marginTop: '48px',
    padding: '1rem',
    width: '90%',
    boxShadow: '0 2px 4px rgba(0,0,0,0.16), 0 2px 4px rgba(0,0,0,0.23);',
  }
});